import React from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import "./styles.scss";
import { useSelector } from "react-redux";
import CurrentlyPlaying from "./CurrentlyPlaying";
import MediaControls from "./MediaControls";
import VolumeControl from "./VolumeControl";

export default ({ landingPage = false }) => {
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 768px)",
  });

  const { currently_playing, volume, progress, playing, queue } = useSelector((state) => state);

  const isActive = !_.isEmpty(currently_playing);

  return (
    <div id="player_controller" className="px-3">
      {isMobileDevice ? (
        !useRouteMatch({ path: "/:slug", extact: true }) && (
          <CurrentlyPlaying isActive={isActive} currently_playing={currently_playing} landingPage={landingPage} />
        )
      ) : (
        <CurrentlyPlaying isActive={isActive} currently_playing={currently_playing} landingPage={landingPage} />
      )}
      <MediaControls
        queue={queue}
        isActive={isActive}
        currently_playing={currently_playing}
        progress={progress}
        playing={playing}
        landingPage={landingPage}
        volume={volume}
      />
      {!isMobileDevice && (
        <div className="d-flex">
          <VolumeControl volume={volume} />
        </div>
      )}
    </div>
  );
};
